import React from 'react';
import './HowItWorks.css';
import connectChecking from './images/how-it-works-connect-checking.svg';
import spendingHabits from './images/how-it-works-spending-habits.svg';
import connectCards from './images/how-it-works-connect-cards.svg';
import seraWorking from './images/how-it-works-sera-working.svg';
import InfoSection from '../common/components/info-section/InfoSection';

function HowItWorks() {
  const title = <React.Fragment>How it works</React.Fragment>;
  const items = [
    {
      img: connectChecking,
      title: <React.Fragment>Connect your checking account to Sera to boost your credit score</React.Fragment>,
      description: 
        <React.Fragment>
          The first step is to connect your primary checking account to Sera. Your security is our priority so we use bank level security to connect your accounts, ensuring you peace of mind. From there, we'll analyze your cash flow so that we can make recommendations for ways to save money and boost your credit.
        </React.Fragment>
    },
    {
      img: spendingHabits,
      title: <React.Fragment>Tells us a little about your monthly spending habits</React.Fragment>,
      description: 
        <React.Fragment>
          We want to get to know you! To provide the best recommendations, we need to understand your monthly expenses. We'll automatically categorize most of your monthly expenses but will also ask you to verify things like how much you spend on fixed vs flexible items. We'll also ask what can be put on a card vs direct debited from your checking account. Lastly, we'll automatically report relevant payments to the credit bureaus to boost your credit.
        </React.Fragment>
    },
    {
      img: connectCards,
      title: <React.Fragment>Connect the credit card you want to pay off</React.Fragment>,
      description: 
        <React.Fragment>
          Paying off those high interest credit cards can be challenging. But Sera is here to help. We'll start with just one. We recommend to start with the card that has the highest interest rate and a balance you don't pay off fully each month. This will maximize the time and money we can help you save. Once you pay off the first one, we'll continue to the next, and so on.
        </React.Fragment>
    },
    {
      img: seraWorking,
      title: <React.Fragment>Let Sera do the hard work for you</React.Fragment>,
      description: 
        <React.Fragment>
          <p>
          Once we know your spending patterns and your debts, Sera will work on improving your credit score and pay the credit card debt more, even with your minimum monthly payments. We'll coordinate with you to confirm your monthly credit card expenses and proactively relocate this amount from your checking account to your credit card upon your payday, essentially pre-paying your monthly credit card expenses. This strategic approach serves to continually reduce your daily credit card debt balance, providing you with interest saving even though you can only make minimum monthly amount.</p>
          <p>
          As your credit score steadily improves, Sera unlocks the potential to leverage Zero Balance Transfer, turbocharging your debt reduction efforts by up to 50% compared to conventional methods. When you halt accumulating additional debt, you'll witness your existing debts vanishing sooner than you might imagine. Our vigilant tracking ensures we showcase your progress and celebrate every milestone along this transformative journey.</p>
        </React.Fragment>
    }

  ]
  return (
    <div className='how-it-works'>
      <InfoSection title={title} items={items} numbered={true} />
    </div>
  )
}

export default HowItWorks;